import React from "react";

import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";

import { Mensagem } from "../../../componentes";
import { ICadastro } from "../../../models";
import { BgQuadrado, Wrapper, MensagemAtencao, Erro } from "./styles";
import { RecuperarSenhaUsuario } from "../../../servicos";

export default function RecuperarSenha() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [mensagem, setMensagem] = React.useState("");
  const [tipo, setTipo] = React.useState("");
  const [exibirAlteracaoSenha, setExibirAlteracaoSenha] = React.useState(false);

  const onSubmitRecover = (data: ICadastro) => {
    recuperarSenha(data.email);
  };

  const recuperarSenha = async (email: string) => {
    if (navigator.onLine) {
      try {
        const resultado = await RecuperarSenhaUsuario(email);
        if (resultado.success) {
          setMensagem("Sua nova senha foi enviada para o seu e-mail!");
          setTipo("sucesso");
          setExibirAlteracaoSenha(true);
        }
      } catch (err) {
        setMensagem("Lamento, falha na comnunicação com o servidor!");
        setTipo("erro");
      }
    } else {
      setMensagem("É necessário conexão com a internet!");
      setTipo("erro");
    }
    setTimeout(() => {
      setMensagem("");
    }, 5000);
  };

  return (
    <Wrapper>
      <BgQuadrado />
      {!exibirAlteracaoSenha ? (
        <form onSubmit={handleSubmit(onSubmitRecover)}>
          <h2>RECUPERAR SENHA</h2>
          <input
            {...register("email", { required: true })}
            placeholder="E-mail"
          />
          {errors.email && (
            <Erro>
              <span>O campo email é obrigatório!</span>
            </Erro>
          )}
          <input className="input-submit" type="submit" value="Solicitar" />
        </form>
      ) : (
        <MensagemAtencao>
          <h2>ENVIADO COM SUCESSO</h2>
          <h3>
            Em instantes você receberá em seu e-mail uma senha temporária.
          </h3>
          <p>
            Após obter a senha temporária, sugerimos que a altere com uma nova
            senha de sua preferência!
          </p>
          <Link to="/atualizar-senha">Alterar senha temporária</Link>
        </MensagemAtencao>
      )}
      <Link to="/login">Voltar</Link>
      {mensagem ? <Mensagem tipo={tipo} frase={mensagem} /> : null}
    </Wrapper>
  );
}
